<div class="guts-p-h-2 m-guts-m-r-1">
  <div class="l_flex l_flex-justify-right guts-p-v-2 action-wrapper">
    <button
      df-button
      dfButtonType="clear"
      [attr.aria-label]="i18n.Core_Close"
      (click)="onCancel()"
      data-dgat="user-experience-details-modal-bd7"
    >
      <df-icon icon="cross"></df-icon>
    </button>
  </div>

  <div
    class="achievements-modal-header l_flex-middle m-l_flex-middle guts-p-b-2"
  >
    <df-icon
      icon="experience"
      class="color-sky zoom-icon"
      size="large"
    ></df-icon>
  </div>

  <div class="left-text guts-p-v-2">
    <p class="par--small par--light">
      {{ i18n.Core_ExperienceDisplayName }}
    </p>
    <h2>{{ userExperienceContent.title | ellipsis: titleLimit }}</h2>
  </div>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.organizationName"
    [title]="i18n.PositionFormCtrl_Organization"
    [value]="userExperienceContent.organizationName"
  ></dgx-achievement-detail>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.startDate && !userExperienceContent.isCurrent"
    [title]="i18n.dgUserOutcomeEditForm_StartDate"
    [value]="userExperienceContent.startDate | date: 'MMMM yyyy'"
  ></dgx-achievement-detail>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.startDate && userExperienceContent.isCurrent"
    [title]="i18n.dgUserOutcomeEditForm_StartDate"
    value="{{ userExperienceContent.startDate | date: 'MMMM yyyy' }} - {{
      i18n.ProfileCtrl_ExperienceDatePresent
    }}"
  ></dgx-achievement-detail>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.endDate && !userExperienceContent.isCurrent"
    [title]="i18n.dgUserOutcomeEditForm_EndDate"
    [value]="userExperienceContent.endDate | date: 'MMMM yyyy'"
  ></dgx-achievement-detail>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.level"
    [title]="i18n.PositionFormCtrl_Seniority"
    [value]="userExperienceContent.level"
  ></dgx-achievement-detail>

  <dgx-achievement-detail
    *ngIf="userExperienceContent.description"
    [title]="i18n.PositionFormCtrl_Description"
    [value]="userExperienceContent.description"
    [isClamped]="false"
    [isLast]="true"
  ></dgx-achievement-detail>

  <!-- Skills -->
  <div class="guts-p-v-2">
    <span
      *ngFor="let skill of displayedSkillNames"
      class="
        btn btn-sm
        bg-color-ebony-a08
        color-ebony
        guts-m-v-quart guts-m-r-half guts-p-r-half
      "
      data-dgat="user-experience-details-modal-183"
    >
      {{ skill }}
    </span>
    <span
      *ngIf="extraSkillCount > 0"
      class="
        btn btn-sm
        bg-color-ebony-a08
        color-ebony
        guts-m-v-quart guts-m-r-half guts-p-r-half
      "
      >+{{ extraSkillCount }}</span
    >
  </div>

  <hr class="footer-hr" />

  <!-- Menu -->
  <div class="action-wrapper guts-p-v-2">
    <dgx-user-experience-actions
      [userExperience]="userExperience"
      (onModalMenu)="onModalMenu()"
    ></dgx-user-experience-actions>
  </div>
</div>
